/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Avatar } from '@material-ui/core';

const RecipientAvatar = (props) => {
    const firstInitial = props.firstName?.[0]?.toUpperCase() || '';
    const lastInitial = props.lastName?.[0]?.toUpperCase() || '';
    return (
        <Avatar
            alt={props.firstName?.[0]?.toUpperCase()}
        >
            {`${firstInitial}${lastInitial}`}
        </Avatar>
    );
};

export default RecipientAvatar;
